/* eslint-disable react/sort-comp */
import React from 'react';
import _ from 'lodash';
import $ from 'jquery';
import PropTypes from 'prop-types';
import { reaction } from 'mobx';
import { observer, inject } from 'mobx-react';
import SelectComponent from '../../shared_components/SelectComponent';
import InputComponent from '../../shared_components/InputComponent';
import ToggleComponent from '../../shared_components/ToggleComponent';
import InformationBoxComponent from '../../shared_components/InformationBoxComponent';

@observer
class MortgageFormComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      labelIdInactiveAfterSetLabel: false,
    };

    this.setProvider = this.setProvider.bind(this);
    this.setLabel = this.setLabel.bind(this);
    this.setProvidersSelectText = this.setProvidersSelectText.bind(this);
    this.setLabelsSelectText = this.setLabelsSelectText.bind(this);
    this.getSelectedProviderAndLabel = this.getSelectedProviderAndLabel.bind(this);
    this.toggleNHG = this.toggleNHG.bind(this);
    this.setHouseValue = this.setHouseValue.bind(this);
    this.setDesiredMortgage = this.setDesiredMortgage.bind(this);
    this.getInterestAndFixedRateTerms = _.debounce(this.getInterestAndFixedRateTerms.bind(this), 600);
    /* Make sure setLoanparts get called after setDesiredMortgage */
    this.setLoanParts = _.debounce(this.setLoanParts.bind(this), 600);
    this.showTextBox = this.showTextBox.bind(this);
    this.copyMortgageFieldsFromOverview = this.copyMortgageFieldsFromOverview.bind(this);
  }

  componentWillMount() {
    this.getSelectedProviderAndLabel();
    this.copyMortgageFieldsFromOverview();
  }

  componentDidMount() {
    this.setLoanParts();
  }

  copyMortgageFieldsFromOverview() {
    const { mortgage, houseValue, nhg, mortgageType } = this.props.OverviewData.overviewForm;
    const { setFormFieldsFromOverview, labelIdFromUrl } = this.props.CalculationFormData;

    if (labelIdFromUrl.active) {
      setFormFieldsFromOverview(mortgageType, mortgage, houseValue, nhg);
    } else {
      setFormFieldsFromOverview(0, 0, 0, 0);
    }
  }

  getInterestAndFixedRateTerms() {
    const {
      mortgageForm,
      getFixedRateTermsForLabel,
      getLabelInterest,
      setAvailableFixedRateTerms,
    } = this.props.CalculationFormData;

    if (mortgageForm.loanparts.length > 0) {
      getFixedRateTermsForLabel(0)
        .then(() => getFixedRateTermsForLabel(1))
        .then(() => getFixedRateTermsForLabel(2))
        .then(() => {
          setAvailableFixedRateTerms(0, 20);
          setAvailableFixedRateTerms(1, 20);
          setAvailableFixedRateTerms(2, 20);
          return getLabelInterest(0);
        })
        .then(() => getLabelInterest(1))
        .then(() => getLabelInterest(2));
    }
  }

  setLoanParts() {
    this.props.CalculationFormData.setInitialLoanpart();
  }

  setProvider(e) {
    this.props.CalculationFormData.responseError = '';
    this.props.CalculationFormData.labelIdFromUrl.active = false;
    this.props.CalculationFormData.setProvider(e.target.value, this.props.CalculationFormData.mortgageForm.labels);
    this.props.CalculationFormData.resetSelectedLabelId();
  }

  setLabel(e) {
    this.props.CalculationFormData.responseError = '';
    this.props.CalculationFormData.labelIdFromUrl.active = false;

    /* Set labelIdInactiveAfterSetLabel. After this action the url wont affect the selected labelId anymore. */
    this.setState({ labelIdInactiveAfterSetLabel: true });

    this.props.CalculationFormData.setLabel(e.target.value);
  }

  setDesiredMortgage(value) {
    const { setDesiredMortgage } = this.props.CalculationFormData;

    setDesiredMortgage(value);
    this.setLoanParts();
    this.getInterestAndFixedRateTerms();
  }

  setHouseValue(value) {
    const { setHouseValue } = this.props.CalculationFormData;
    setHouseValue(value);
    this.getInterestAndFixedRateTerms();
  }

  toggleNHG() {
    this.props.CalculationFormData.toggleNHG();

    this.getInterestAndFixedRateTerms();
  }

  getSelectedProviderAndLabel() {
    let { labels, providers } = this.props.CalculationFormData.mortgageForm;

    if (labels.length > 0 && providers.length > 0) {
      this.setSelectedProviderAndLabel(providers, labels);
    } else {
      reaction(
        () => [this.props.ProviderLabelData.allProviders, this.props.ProviderLabelData.allLabels],
        (providersAndLabels) => {
          if (providersAndLabels[0].length > 0 && providersAndLabels[1].length > 0) {
            this.props.CalculationFormData.responseError = '';

            const newProviders = providersAndLabels[0];
            const newLabels = providersAndLabels[1];

            /* Set providers and labels in mortgageForm */
            providers = newProviders;
            labels = newLabels;

            this.setSelectedProviderAndLabel(newProviders, newLabels);
          }
        },
      );
    }
  }

  setSelectedProviderAndLabel(providers, labels) {
    const { labelIdFromUrl, setProvider, setLabel, setLabelIdFromUrl } = this.props.CalculationFormData;
    let { labelId } = this.props.CalculationFormData.mortgageForm;

    setLabelIdFromUrl();

    /* Check if labelIdFromUrl is active */
    if ((labelIdFromUrl.active && labelIdFromUrl.labelId !== 0)) {
      /* Get labelId */
      labelId = labelIdFromUrl.labelId;
    }

    const foundLabel = labels.find(label => label.id === labelId);

    /* Get provider for this labelId */
    const foundProvider = providers.find(provider => provider.id === foundLabel?.providerId);

    /* Set provider */
    setProvider(foundProvider?.id, labels);
    this.setProvidersSelectText(providers, foundProvider?.id);

    /* Set label */
    setLabel(labelId);
    this.setLabelsSelectText(labels, foundLabel?.id);
  }

  setProvidersSelectText(providers, providerId) {
    const selectedProvider = providers.find(provider => provider.id === providerId);
    if (selectedProvider) {
      $('select[name=selected-provider]')
        .siblings('.text')
        .text(selectedProvider.name);
    }
  }

  setLabelsSelectText(labels, labelId) {
    const selectedLabel = labels.find(label => label.id === labelId);
    if (selectedLabel) {
      $('select[name=selected-label]')
        .siblings('.text')
        .text(selectedLabel.labelName);
    }
  }

  showTextBox(data, event) {
    event.stopPropagation();
    this.props.ModalData.openModal(data);
  }

  render() {
    const {
      providers,
      filteredLabels,
      mortgage,
      nhg,
      houseValue,
      providerId,
      loanparts,
    } = this.props.CalculationFormData.mortgageForm;
    let { labelId } = this.props.CalculationFormData.mortgageForm;
    const { labelIdFromUrl, setLabelIdFromUrl } = this.props.CalculationFormData;

    const currency = true;

    const showNhgSwitch = true;
    const { informationBoxData } = this.props.InformationBoxData;

    setLabelIdFromUrl();
    if (!this.state.labelIdInactiveAfterSetLabel && labelIdFromUrl.active && labelIdFromUrl.labelId !== 0) {
      labelId = labelIdFromUrl.labelId;
    }

    /* Select first labels if none is selected */
    let selectedImage;
    let selectedLogo;

    if (providers.length > 0) {
      selectedImage = providers.find(provider => provider.id === providerId);

      /* Because labels are loaded async, make sure there is a logo property */
      selectedLogo = _.has(selectedImage, 'logo') ? selectedImage.logo : '';
    }

    /* Drop shadow beneath MortgageFormComponent when input is valid and loanparts appear. */
    const validInputClassName = (loanparts.length > 0 && labelId > 0) ?
      'calculation-form__mortgage-form--valid' : '';

    return (
      <div className={`calculation-form__mortgage-form no-side-padding ${validInputClassName}`} >
        <div className="row columns">
          <div className="columns medium-15">
            <img
              className="calculation-form__mortgage-form__label-logo"
              src={selectedLogo} alt=""
            />
          </div>
        </div>
        <div className="row columns">
          <div className="medium-15 medium-offset-2 large-17 large-offset-1 columns calculation-form__mortgage-form__selectrow">
            <SelectComponent
              onChangeHandler={this.setProvider}
              selected={providerId}
              labels={providers}
              name="selected-provider"
              label={'Verstrekker'}
              classNames={'search'}
            >
              <InformationBoxComponent
                classNames="info-box-select"
                onClickHandler={
                  (event) => {
                    this.showTextBox(informationBoxData.label, event);
                  }
                }
              />
            </SelectComponent>
          </div>
          <div className="medium-15 large-17 columns">
            <SelectComponent
              onChangeHandler={this.setLabel}
              selected={labelId}
              labels={filteredLabels}
              name="selected-label"
              label={'Product'}
              classNames={'search'}
            />
          </div>
          <div className="medium-15 large-17 columns">
            <InputComponent
              currency={currency}
              onChangeHandler={this.setHouseValue}
              value={houseValue}
              placeholder={'Waarde woning'}
              label={'Waarde woning'}
            >
              <InformationBoxComponent
                classNames="info-box-input"
                onClickHandler={(event) => { this.showTextBox(informationBoxData.houseValue, event); }}
              />
            </InputComponent>
          </div>
          <div className="medium-15 large-17 columns">
            <InputComponent
              currency={currency}
              onChangeHandler={this.setDesiredMortgage}
              value={mortgage}
              placeholder={'Gewenste hypotheek'}
              label={'Gewenste hypotheek'}
            >
              <InformationBoxComponent
                classNames="info-box-input"
                onClickHandler={(event) => { this.showTextBox(informationBoxData.mortgage, event); }}
              />
            </InputComponent>
          </div>
          <div className="large-14 medium-20 end columns">
            <ToggleComponent
              show={showNhgSwitch}
              handleInputChange={this.toggleNHG}
              label={'NHG'}
              checked={nhg}
              id={'toggle-nhg'}
              classNames={'toggle-nhg'}
            >
              <InformationBoxComponent
                classNames="info-box-toggle"
                onClickHandler={(event) => { this.showTextBox(informationBoxData.nhg, event); }}
              />
            </ToggleComponent></div>
        </div>
        <hr className={'linearGradient'} />
      </div>
    );
  }
}

MortgageFormComponent.propTypes = {
  ProviderLabelData: PropTypes.shape({
    allProviders: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
    allLabels: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
  }),
  ModalData: PropTypes.shape({
    openModal: PropTypes.func,
  }),
  InformationBoxData: PropTypes.shape({
    informationBoxData: PropTypes.shape({
      header: PropTypes.string,
      text: PropTypes.string,
    }),
  }),
  OverviewData: PropTypes.shape({
    overviewForm: PropTypes.shape({
      mortgage: PropTypes.number,
      houseValue: PropTypes.number,
      nhg: PropTypes.number,
      mortgageType: PropTypes.number,
    }),
  }),
  CalculationFormData: PropTypes.shape({
    responseError: PropTypes.string,
    labelIdFromUrl: PropTypes.shape({
      active: PropTypes.bool,
    }),
    setLabelIdFromUrl: PropTypes.func,
    getProviders: PropTypes.func,
    getLabels: PropTypes.func,
    setProvider: PropTypes.func,
    setFormFieldsFromOverview: PropTypes.func,
    resetSelectedLabelId: PropTypes.func,
    mortgageForm: PropTypes.shape({
      mortgage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      houseValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      providers: PropTypes.oneOfType([
        PropTypes.shape({}),
        PropTypes.arrayOf(PropTypes.shape({})),
      ]),
      labels: PropTypes.arrayOf(PropTypes.shape({})),
      filteredLabels: PropTypes.arrayOf(PropTypes.shape({})),
      labelId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
      providerId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
      nhg: PropTypes.bool,
      loanparts: PropTypes.arrayOf(PropTypes.number),
    }),
    getFixedRateTermsForLabel: PropTypes.func,
    getLabelInterest: PropTypes.func,
    setAvailableFixedRateTerms: PropTypes.func,
    setLoanparts: PropTypes.func,
    setLabel: PropTypes.func,
    setDesiredMortgage: PropTypes.func,
    setHouseValue: PropTypes.func,
    toggleNHG: PropTypes.func,
  }),
};

MortgageFormComponent.defaultProps = {
  ProviderLabelData: {
    allProviders: [],
    allLabels: [],
  },
  ModalData: {
    openModal: () => {},
  },
  InformationBoxData: {
    informationBoxData: {
      header: '',
      text: '',
    },
  },
  OverviewData: {
    overviewForm: {
      mortgage: 0,
      houseValue: 0,
      nhg: 0,
      mortgageType: 0,
    },
  },
  CalculationFormData: {
    responseError: '',
    labelIdFromUrl: {},
    setProvider: () => {},
    setFormFieldsFromOverview: () => {},
    resetSelectedLabelId: () => {},
    setLabelIdFromUrl: () => {},
    mortgageForm: {
      mortgage: 0,
      houseValue: 0,
      providers: [],
      labels: [],
      filteredLabels: [],
      labelId: '',
      providerId: '',
      nhg: false,
      loanparts: [],
    },
    getFixedRateTermsForLabel: () => {},
    getLabelInterest: () => {},
    setAvailableFixedRateTerms: () => {},
    setLoanparts: () => {},
    setDesiredMortgage: () => {},
    setHouseValue: () => {},
    setLabel: () => {},
    toggleNHG: () => {},
  },
};


export default inject('CalculationFormData', 'OverviewData',
  'InformationBoxData', 'ModalData', 'ProviderLabelData')(MortgageFormComponent);

